import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import UI from '../../common/UI';

interface PageLoaderProps {
  throttled?: boolean;
  height?: number | string;
}

const PageLoader = ({ throttled, height }: PageLoaderProps) => {
  const { t } = useTranslation();

  const [showMessage, setShowMessage] = useState(throttled);
  const message = throttled ? t('common:validation.too_many_attempts') : t('slow_fetch_message');

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setShowMessage(true);
    }, 3000);

    return () => window.clearTimeout(timer);
  }, []);

  return (
    <UI.Div sc={{ textAlign: 'center' }}>
      <UI.PageLoader height={height} />
      {showMessage && message}
    </UI.Div>
  );
};

export default PageLoader;
